<template>
    <Container :list="this.$nav22" title="学子风采" v-if="isMaxScreen">
        <div class="szll">
            <div class="breadcrumb">
              <router-link to="/" class="breadcrumb-item">
                首页
              </router-link>
              <!-- -
              <router-link to="/xxjj/xxgk?ids=0" class="breadcrumb-item">
                学校简介
              </router-link> -->
              -
              <span class="breadcrumb-item">学子风采</span>
            </div>
         <ul class="tsnn_bottom">
            <li v-for="(item, index) in list"
                :key="item.id"
                @click="toPage(item)"
                :class="(index + 1) % 3 == 0 ? 'no_margin':''">
                <img
                  class="teacher_img"
                  :src="item.photo_url"
                />
                <div class="tsnn_title">{{item.name}}</div>
            </li>

          </ul>
        </div>
         <Pagination
            v-if="total"
            :total="total"
            @getList="getList"
            :queryParams="queryParams">
        </Pagination>
    </Container>

    <StudentH5 v-else />
</template>

<script>
import Container from '@/components/Container'
import Pagination from '@/components/pagination'
import StudentH5 from '@/views/app/student/index'
export default {
  name: 'student',
  components: { Container, Pagination, StudentH5 },
  props: {},
  data () {
    return {
      isMaxScreen: true,
      total: 0,
      list: [],
      queryParams: {
        page: 1,
        page_size: 15,
        column_id: 2
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {
    async getList () {
      const { data, total } = await this.$get('/ow/character', this.queryParams)
      // console.log(data)
      this.list = data
      this.total = total
    },
    toPage (item) {
      this.$router.push({
        path: '/xxjj/details?ids=0',
        query: {
          id: item.id,
          title: '学子风采'
        }
      })
      // this.$store.commit('setSidebar', this.$nav6)
    }
  }
}
</script>

<style lang="scss" scoped>
  .szll {
     width: 890px;
     font-size: 16px;
     color: #383737;
    .tsnn_bottom {
       display: flex;
       flex-wrap: wrap;

       li{
        margin-right: 24px;
        margin-bottom: 24px;
        cursor: pointer;
        position: relative;
        .teacher_img {
           width: 280px;
           height: 180px;
           object-fit: cover;
        }
        .tsnn_title {
           position: absolute;
           bottom: 2px;
           left: 0;
           width: 100%;
           height: 34px;
           line-height: 34px;
           font-size: 16px;
           background:  rgba(0, 0, 0, 0.5);
           color: #fff;
           text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 12px;
         }
       }
       .no_margin {
         margin-right: 0!important;
       }
     }
  }
</style>
